"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const AddProductReviewMutation = (0, graphql_tag_1.default) `
  mutation addProductReviewMutation(
    $characteristics: [ReviewCharacteristicInput]!
    $campaignId: String
    $productId: ID!
    $rating: Int!
    $recommended: Boolean!
    $text: String!
    $title: String!
    $userId: ID
    $userLocation: String
    $userName: String
    $reviewDataJWT: String
  ) {
    addProductReview(
      reviewRequest: {
        characteristics: $characteristics
        metadata: { campaignId: $campaignId }
        productId: $productId
        rating: $rating
        recommended: $recommended
        text: $text
        title: $title
        user: { id: $userId, name: $userName, location: $userLocation }
        reviewDataJWT: $reviewDataJWT
      }
    ) {
      id
      status
      payloadErrors {
        field
        message
      }
    }
  }
`;
exports.default = AddProductReviewMutation;
